import { GlAlert, GlLabel } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { last } from 'lodash-es';
import { calculateJiraImportLabel, isInProgress, setFinishedAlertHideMap, shouldShowFinishedAlert } from '~/jira_import/utils/jira_import_utils';
import { n__ } from '~/locale';
import getIssuesListDetailsQuery from '../graphql/get_issues_list_details.query.graphql';
export default {
    name: 'JiraIssuesImportStatus',
    components: {
        GlAlert,
        GlLabel
    },
    props: {
        issuesPath: {
            type: String,
            required: true
        },
        projectPath: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            jiraImport: {}
        };
    },
    apollo: {
        jiraImport: {
            query: getIssuesListDetailsQuery,
            variables () {
                return {
                    fullPath: this.projectPath
                };
            },
            update: ({ project })=>{
                const label = calculateJiraImportLabel(project.jiraImports.nodes, project.issues.nodes.flatMap(({ labels })=>labels.nodes));
                return {
                    importedIssuesCount: last(project.jiraImports.nodes)?.importedIssuesCount,
                    label,
                    shouldShowFinishedAlert: shouldShowFinishedAlert(label.title, project.jiraImportStatus),
                    shouldShowInProgressAlert: isInProgress(project.jiraImportStatus)
                };
            }
        }
    },
    computed: {
        finishedMessage () {
            return n__('%d issue successfully imported with the label', '%d issues successfully imported with the label', this.jiraImport.importedIssuesCount);
        },
        labelTarget () {
            return `${this.issuesPath}?label_name[]=${encodeURIComponent(this.jiraImport.label.title)}`;
        },
        shouldRender () {
            return this.jiraImport.shouldShowInProgressAlert || this.jiraImport.shouldShowFinishedAlert;
        }
    },
    methods: {
        hideFinishedAlert () {
            setFinishedAlertHideMap(this.jiraImport.label.title);
            this.jiraImport.shouldShowFinishedAlert = false;
        },
        hideInProgressAlert () {
            this.jiraImport.shouldShowInProgressAlert = false;
        }
    }
};
